import { FC } from "react";
import { Range, getTrackBackground } from "react-range";

import { SetNumberValueType } from "@interfaces/filters";
import { useFilters } from "@context/filter";

interface Props {
  min: number;
  max: number;
  step: number;
  values: number[];
  type: SetNumberValueType;
  text: string;
  price?: boolean;
}

const RangeFilter: FC<Props> = ({
  min,
  max,
  step,
  values,
  type,
  text,
  price,
}) => {
  const { dispatch } = useFilters();

  return (
    <div className="w-full p-4 space-y-4">
      <div className="text-center">{text}</div>
      <Range
        step={step}
        min={min}
        max={max}
        values={values}
        onChange={(value) => dispatch({ type, value })}
        renderTrack={({ props, children }) => (
          <div
            {...props}
            style={{
              ...props.style,
              background: getTrackBackground({
                min,
                max,
                values,
                colors: ["#ccc", "rgba(239, 68, 68, 2)", "#ccc"],
              }),
            }}
            className="h-1 w-full"
          >
            {children}
          </div>
        )}
        renderThumb={({ props }) => (
          <div
            {...props}
            style={{ ...props.style }}
            className="rounded-full h-4 w-4 bg-red-500 ring-4 ring-red-500 ring-opacity-0 hover:ring-opacity-25 focus:ring-red-500 focus:ring-opacity-25 focus:outline-none"
          />
        )}
      />
      <div className="flex justify-between">
        <span>
          {values[0]} {price ? "€" : "cm"}
        </span>
        <span>
          {values[1]} {price ? "€" : "cm"}
        </span>
      </div>
    </div>
  );
};

export default RangeFilter;
